import styled from 'styled-components';



export const HelpContainerViewStyle = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 7px;
  padding-left: 5px;
  padding-right: 5px;
`;

export const HelpTextView = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 1;
`;

export const HelpTextComponentStyle = styled.p`
  margin-top: 0;
  margin-bottom: 0;
  font-size: 12px;
  font-style: italic;
`;

export const HelpCountTextStyle = styled.p`
  margin-top: 0;
  margin-bottom: 0;
  margin-left: 5px;
  font-size: 12px;
`;
